import type { TaskBucket } from '../schemas/task'

export const PRIORITY_ORDER: Record<TaskBucket, number> = {
  urgent: 0,
  week: 1,
  later: 2,
  waiting: 3,
  ignored: 4,
}

export const compareBucket = (a: TaskBucket, b: TaskBucket): number =>
  PRIORITY_ORDER[a] - PRIORITY_ORDER[b]
